



















































import Vue from 'vue';
import { IEmailBlueprint, IState } from '@/store/types';
import SmallListLoader from '@/components/UI/Loader/SmallListLoader.vue';
import { FETCH_REACTIVATION_CAMPAIGN_BLUEPRINT } from '@/store/action-types';

export default Vue.extend({
  name: 'ReactivationCampaignSequence',
  components: {
    SmallListLoader,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    const state = this.$store.state as IState;
    const activeCampaignId = state.org?.reactivation?.activeCampaign;
    await this.$store.dispatch(FETCH_REACTIVATION_CAMPAIGN_BLUEPRINT, activeCampaignId);
    this.loading = false;
  },
  computed: {
    activeCampaignId(): string | undefined {
      const state = this.$store.state as IState;
      return state.org?.reactivation?.activeCampaign;
    },
    emails(): IEmailBlueprint[] {
      const state = this.$store.state as IState;
      if (this.activeCampaignId) {
        const activeCampaign = state.reactivationCampaignBlueprints[this.activeCampaignId];
        if (activeCampaign) {
          return [...activeCampaign.emails].sort((a, b) => a.sendOnDay - b.sendOnDay);
        }
      }
      return [];
    },
  },
});
